import { useEffect, useRef, useState } from 'react'
import Box from '@mui/joy/Box'
import Modal from '@mui/joy/Modal'
import ModalDialog from '@mui/joy/ModalDialog'
import ModalOverflow from '@mui/joy/ModalOverflow'
import DialogTitle from '@mui/joy/DialogTitle'

export const Pricing = () => {
    const [isReady, setIsReady] = useState(false)
    const pricingId = useRef(null)
    const publicKey = useRef(null)
    const clientRefId = useRef(null)

    useEffect(() => {
        console.log('useEff')
        const script = document.createElement('script')
        script.src = 'https://js.stripe.com/v3/pricing-table.js'
        script.async = true
        document.body.appendChild(script)

        const pricingIdStr = document.getElementById(
            'stripePricingTableId'
        ).innerText
        pricingId.current = JSON.parse(pricingIdStr)
        const publicKeyStr =
            document.getElementById('stripePublicKey').innerText
        publicKey.current = JSON.parse(publicKeyStr)
        const clientRefIdStr =
            document.getElementById('clientReferenceId').innerText
        clientRefId.current = JSON.parse(clientRefIdStr)
        setIsReady(true)
        return () => {
            document.body.removeChild(script)
        }
    }, [])

    return (
        <Modal open={isReady} onClose={console.log} size="lg" variant="solid">
            <ModalOverflow>
                <ModalDialog sx={{ width: '45%' }}>
                    <DialogTitle>Choose a plan</DialogTitle>
                    <Box>
                        <stripe-pricing-table
                            pricing-table-id={pricingId.current}
                            publishable-key={publicKey.current}
                            client-reference-id={clientRefId.current}
                        ></stripe-pricing-table>
                    </Box>
                </ModalDialog>
            </ModalOverflow>
        </Modal>
    )
}
